import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_LOGIN,
  GET_OTP,
  GET_ADDMAGICTOKEN,
  GET_VERIFYMAGICTOKEN,
  GET_COUNTRYCODE,
} from 'resources/actionTypes';
import {
  loginApi,
  otpApi,
  countryCodeApi,
} from 'services/AuthService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from 'redux/store';
import { onLoaderTrigger } from 'redux/actions/commonAction';

function* fetchLogin(action) {
  const payload = action.payload || {};
  const userLogin = yield call(loginApi, payload?.loginPayload?.userDetails);
  if (userLogin.success) {
    yield put({ type: GET_LOGIN.GET_LOGIN_SUCCESS, userLogin: userLogin });

    if(payload?.loginPayload?.actionType === "login") {
      payload?.setOnOtp(true);
      localStorage.setItem('mobile', payload?.loginPayload?.userDetails?.mobileOrEmail);
      localStorage.setItem('code', payload?.loginPayload?.userDetails?.countryCode);
    }

    localStorage.setItem('secretToken', userLogin.data[0].otpSecret);
    toast.success(userLogin.message);
  } else {
    yield put({ type: GET_LOGIN.GET_LOGIN_FAILED, message: userLogin.message });
    toast.error(userLogin?.message || 'Login failed');
  }
}

export function* loginSaga() {
  yield takeEvery(GET_LOGIN.GET_LOGIN_REQUESTED, fetchLogin);
}

function* fetchOtp(action) {
  const payload = action.payload || {};
  const userOtp = yield call(otpApi, payload.userOtp);
  if (userOtp.success) {
    localStorage.setItem('token', userOtp?.data[0]?.token);
    localStorage.setItem('userId', userOtp?.data[0]?.userId);
    yield put({ type: GET_OTP.GET_OTP_SUCCESS, userOtp: userOtp });
    toast.success(userOtp.message);
    window.location.replace('/companies');
  } else {
    yield put({ type: GET_OTP.GET_OTP_FAILED, message: userOtp.message });
    toast.error(userOtp?.message || 'Otp failed');
    payload?.otpActions?.resetOtp();
    payload?.otpActions?.setAutoFocusOtp(true);
  }
}

export function* otpSaga() {
  yield takeEvery(GET_OTP.GET_OTP_REQUESTED, fetchOtp);
}

function* fetchAddMagicToken(action) {
  const token = localStorage.getItem('token');
  yield put({ type: GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_SUCCESS });
  window.open(
    `${
      process.env.REACT_APP_B2C_DOMAIN +
      '/login?Token='+token
    }`,
    '_blank'
  );
}

export function* addMagicTokenSaga() {
  yield takeEvery(
    GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_REQUESTED,
    fetchAddMagicToken
  );
}

function* fetchVerifyMagicToken(action) {
    yield put({ type: GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_SUCCESS });
    window.location.replace('/companies');
}

export function* verifyMagicTokenSaga() {
  yield takeEvery(
    GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_REQUESTED,
    fetchVerifyMagicToken
  );
}

function* getCountryCodeWorker() {
  store.dispatch(onLoaderTrigger(true));
  const countryCodeResponse = yield call(countryCodeApi);
  if (countryCodeResponse.success) {
    yield put({ type: GET_COUNTRYCODE.GET_COUNTRYCODE_SUCCESS, countryCodeList: countryCodeResponse });
  } else {
    yield put({ type: GET_COUNTRYCODE.GET_COUNTRYCODE_FAILED, message: countryCodeResponse.message });
      toast.error(countryCodeResponse.message || "Country code Fetching Failed");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* getCountryCodeWathcer() {
  yield takeEvery(GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED, getCountryCodeWorker);
}